import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { NextUIProvider } from '@nextui-org/react';

ReactDOM.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
  document.getElementById('root')
);

